{
  "name": "ITC Novarese Std",
  "size": 72,
  "bold": true,
  "italic": false,
  "width": 979,
  "height": 302,
  "characters": {
    "0":{"x":772,"y":76,"width":52,"height":60,"originX":4,"originY":53,"advance":44},
    "1":{"x":321,"y":76,"width":37,"height":61,"originX":-3,"originY":54,"advance":44},
    "2":{"x":0,"y":137,"width":49,"height":59,"originX":3,"originY":53,"advance":44},
    "3":{"x":225,"y":76,"width":49,"height":61,"originX":3,"originY":53,"advance":44},
    "4":{"x":359,"y":196,"width":52,"height":57,"originX":5,"originY":51,"advance":44},
    "5":{"x":824,"y":76,"width":49,"height":60,"originX":2,"originY":51,"advance":44},
    "6":{"x":918,"y":0,"width":51,"height":62,"originX":4,"originY":55,"advance":44},
    "7":{"x":411,"y":196,"width":51,"height":57,"originX":2,"originY":51,"advance":44},
    "8":{"x":121,"y":76,"width":52,"height":61,"originX":4,"originY":53,"advance":44},
    "9":{"x":715,"y":0,"width":51,"height":63,"originX":4,"originY":53,"advance":44},
    " ":{"x":804,"y":254,"width":12,"height":12,"originX":6,"originY":6,"advance":22},
    "!":{"x":49,"y":137,"width":30,"height":59,"originX":1,"originY":51,"advance":28},
    "\"":{"x":532,"y":254,"width":37,"height":32,"originX":0,"originY":51,"advance":36},
    "#":{"x":0,"y":196,"width":49,"height":58,"originX":2,"originY":52,"advance":44},
    "$":{"x":32,"y":0,"width":52,"height":73,"originX":4,"originY":59,"advance":44},
    "%":{"x":800,"y":0,"width":62,"height":62,"originX":5,"originY":54,"advance":52},
    "&":{"x":0,"y":76,"width":64,"height":61,"originX":4,"originY":53,"advance":56},
    "'":{"x":595,"y":254,"width":22,"height":32,"originX":3,"originY":51,"advance":16},
    "(":{"x":84,"y":0,"width":33,"height":73,"originX":1,"originY":54,"advance":28},
    ")":{"x":117,"y":0,"width":33,"height":73,"originX":4,"originY":54,"advance":28},
    "*":{"x":496,"y":254,"width":36,"height":36,"originX":2,"originY":51,"advance":32},
    "+":{"x":0,"y":254,"width":49,"height":48,"originX":3,"originY":42,"advance":43},
    ",":{"x":569,"y":254,"width":26,"height":32,"originX":4,"originY":17,"advance":22},
    "-":{"x":617,"y":254,"width":34,"height":29,"originX":5,"originY":33,"advance":24},
    ".":{"x":728,"y":254,"width":27,"height":26,"originX":2,"originY":19,"advance":22},
    "/":{"x":637,"y":0,"width":39,"height":64,"originX":9,"originY":55,"advance":20},
    ":":{"x":375,"y":254,"width":27,"height":45,"originX":2,"originY":38,"advance":22},
    ";":{"x":462,"y":196,"width":28,"height":53,"originX":4,"originY":38,"advance":22},
    "<":{"x":679,"y":196,"width":49,"height":49,"originX":3,"originY":43,"advance":43},
    "=":{"x":447,"y":254,"width":49,"height":36,"originX":3,"originY":36,"advance":43},
    ">":{"x":728,"y":196,"width":49,"height":49,"originX":3,"originY":43,"advance":43},
    "?":{"x":274,"y":76,"width":47,"height":61,"originX":3,"originY":53,"advance":40},
    "@":{"x":487,"y":76,"width":61,"height":60,"originX":2,"originY":53,"advance":57},
    "A":{"x":239,"y":137,"width":66,"height":58,"originX":7,"originY":52,"advance":52},
    "B":{"x":190,"y":196,"width":60,"height":57,"originX":4,"originY":51,"advance":52},
    "C":{"x":173,"y":76,"width":52,"height":61,"originX":4,"originY":53,"advance":44},
    "D":{"x":127,"y":196,"width":63,"height":57,"originX":4,"originY":51,"advance":56},
    "E":{"x":250,"y":196,"width":56,"height":57,"originX":4,"originY":51,"advance":48},
    "F":{"x":909,"y":137,"width":53,"height":58,"originX":4,"originY":51,"advance":44},
    "G":{"x":548,"y":76,"width":60,"height":60,"originX":4,"originY":53,"advance":52},
    "H":{"x":305,"y":137,"width":64,"height":58,"originX":4,"originY":52,"advance":56},
    "I":{"x":91,"y":196,"width":36,"height":58,"originX":4,"originY":52,"advance":28},
    "J":{"x":277,"y":0,"width":38,"height":69,"originX":6,"originY":52,"advance":28},
    "K":{"x":558,"y":137,"width":61,"height":58,"originX":4,"originY":52,"advance":52},
    "L":{"x":855,"y":137,"width":54,"height":58,"originX":4,"originY":52,"advance":44},
    "M":{"x":161,"y":137,"width":78,"height":58,"originX":5,"originY":52,"advance":68},
    "N":{"x":369,"y":137,"width":64,"height":58,"originX":4,"originY":52,"advance":56},
    "O":{"x":423,"y":76,"width":64,"height":60,"originX":4,"originY":53,"advance":56},
    "P":{"x":619,"y":137,"width":60,"height":58,"originX":4,"originY":51,"advance":52},
    "Q":{"x":358,"y":76,"width":65,"height":60,"originX":4,"originY":53,"advance":56},
    "R":{"x":496,"y":137,"width":62,"height":58,"originX":4,"originY":51,"advance":52},
    "S":{"x":719,"y":76,"width":53,"height":60,"originX":4,"originY":53,"advance":44},
    "T":{"x":679,"y":137,"width":59,"height":58,"originX":5,"originY":51,"advance":48},
    "U":{"x":873,"y":76,"width":60,"height":59,"originX":4,"originY":52,"advance":52},
    "V":{"x":433,"y":137,"width":63,"height":58,"originX":7,"originY":52,"advance":48},
    "W":{"x":79,"y":137,"width":82,"height":58,"originX":7,"originY":52,"advance":68},
    "X":{"x":738,"y":137,"width":59,"height":58,"originX":5,"originY":52,"advance":48},
    "Y":{"x":797,"y":137,"width":58,"height":58,"originX":7,"originY":52,"advance":44},
    "Z":{"x":306,"y":196,"width":53,"height":57,"originX":4,"originY":51,"advance":44},
    "[":{"x":220,"y":0,"width":29,"height":72,"originX":-1,"originY":54,"advance":28},
    "\\":{"x":676,"y":0,"width":39,"height":64,"originX":9,"originY":55,"advance":20},
    "]":{"x":249,"y":0,"width":28,"height":72,"originX":1,"originY":54,"advance":28},
    "^":{"x":402,"y":254,"width":45,"height":38,"originX":1,"originY":51,"advance":43},
    "_":{"x":755,"y":254,"width":49,"height":16,"originX":6,"originY":1,"advance":36},
    "`":{"x":697,"y":254,"width":31,"height":26,"originX":3,"originY":57,"advance":24},
    "a":{"x":822,"y":196,"width":53,"height":48,"originX":4,"originY":40,"advance":44},
    "b":{"x":315,"y":0,"width":56,"height":66,"originX":4,"originY":58,"advance":48},
    "c":{"x":49,"y":254,"width":48,"height":48,"originX":4,"originY":40,"advance":40},
    "d":{"x":371,"y":0,"width":56,"height":66,"originX":4,"originY":58,"advance":48},
    "e":{"x":875,"y":196,"width":52,"height":48,"originX":4,"originY":40,"advance":44},
    "f":{"x":561,"y":0,"width":42,"height":65,"originX":6,"originY":58,"advance":28},
    "g":{"x":64,"y":76,"width":57,"height":61,"originX":6,"originY":40,"advance":44},
    "h":{"x":505,"y":0,"width":56,"height":65,"originX":4,"originY":58,"advance":48},
    "i":{"x":766,"y":0,"width":34,"height":63,"originX":5,"originY":57,"advance":24},
    "j":{"x":0,"y":0,"width":32,"height":76,"originX":6,"originY":57,"advance":24},
    "k":{"x":448,"y":0,"width":57,"height":65,"originX":4,"originY":58,"advance":48},
    "l":{"x":603,"y":0,"width":34,"height":65,"originX":5,"originY":58,"advance":24},
    "m":{"x":546,"y":196,"width":77,"height":49,"originX":4,"originY":42,"advance":68},
    "n":{"x":623,"y":196,"width":56,"height":49,"originX":4,"originY":42,"advance":48},
    "o":{"x":927,"y":196,"width":52,"height":48,"originX":4,"originY":40,"advance":44},
    "p":{"x":862,"y":0,"width":56,"height":62,"originX":4,"originY":42,"advance":48},
    "q":{"x":608,"y":76,"width":56,"height":60,"originX":4,"originY":40,"advance":48},
    "r":{"x":777,"y":196,"width":45,"height":49,"originX":4,"originY":42,"advance":36},
    "s":{"x":97,"y":254,"width":47,"height":48,"originX":3,"originY":40,"advance":40},
    "t":{"x":49,"y":196,"width":42,"height":58,"originX":6,"originY":50,"advance":32},
    "u":{"x":490,"y":196,"width":56,"height":50,"originX":4,"originY":42,"advance":48},
    "v":{"x":219,"y":254,"width":55,"height":46,"originX":7,"originY":39,"advance":40},
    "w":{"x":144,"y":254,"width":75,"height":46,"originX":7,"originY":39,"advance":60},
    "x":{"x":274,"y":254,"width":55,"height":46,"originX":5,"originY":39,"advance":44},
    "y":{"x":664,"y":76,"width":55,"height":60,"originX":7,"originY":39,"advance":40},
    "z":{"x":329,"y":254,"width":46,"height":45,"originX":5,"originY":39,"advance":36},
    "{":{"x":150,"y":0,"width":35,"height":72,"originX":4,"originY":54,"advance":28},
    "|":{"x":427,"y":0,"width":21,"height":66,"originX":2,"originY":58,"advance":16},
    "}":{"x":185,"y":0,"width":35,"height":72,"originX":3,"originY":54,"advance":28},
    "~":{"x":651,"y":254,"width":46,"height":26,"originX":1,"originY":31,"advance":43}
  }
}